/**
 * @desc 자음만 반환하는 함수
 * @param {string} str 문자열
 * @returns {string} 자음만 추출된 문자열
 */
export const extractConsonants = (str: string): string => {
    const consonants = new Set(['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', 'ㄲ', 'ㄸ', 'ㅃ', 'ㅆ', 'ㅉ']);

    const consonantArr = Array.from(str)
        .filter((char) => consonants.has(char))
        .join('');

    return consonantArr;
};
